// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__2bZHX","amount":"Amount_amount__2eqrZ","tip":"Amount_tip__1ZCE3","tipHeader":"Amount_tipHeader__3-w7e","tipsWrap":"Amount_tipsWrap__3fVRI"};